// ScrollToTop.js — keep viewport at top on navigation and full page refresh
import { useEffect, useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  // Prevent the browser from restoring scroll position after reload / bfcache
  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
  }, []);

  // Run before paint so the first frame is already at the top (fixes refresh → footer jump)
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
    const root = document.scrollingElement || document.documentElement;
    root.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, [pathname]);

  return null;
};

export default ScrollToTop;
